import $ from "jquery";
import "slick-carousel";

const CarouselCategories = () => {
  // Slides to scroll hack
  const slideopts = [
    { breakpoint: 767, slidesToScroll: 3 },
    { breakpoint: 1024, slidesToScroll: 3 },
    { breakpoint: 1279, slidesToScroll: 4 },
    { breakpoint: 1919, slidesToScroll: 4 },
    { breakpoint: 2559, slidesToScroll: 6 },
  ];

  var setSlidesToScroll = function (count) {
    let scrollSlides = 4;
    const vw = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );

    // Reset to default values and change slides scroll number
    slideopts.forEach((el) => {
      if (vw >= el.breakpoint) scrollSlides = el.slidesToScroll;
    });
    $(".episode__wrapper").slick(
      "slickSetOption",
      "slidesToScroll",
      scrollSlides
    );
    if (count > 0)
      $(".episode__wrapper").slick("slickSetOption", "slidesToScroll", count);
  };

  // Select category callback
  var onSlideSelect = function (e) {
    $("#view__categories")
      .find(".category__item")
      .each((i, el) => {
        $(el).removeClass("category__item--active");
      });
    $(e.target).addClass("category__item--active");
    var slide_title = $(e.target).text().replace(/\n/, ""); // Safari fix

    // Filter episodes
    setSlidesToScroll();
    $(".episode__wrapper").each((i, el) => {
      $(el).addClass("episode__wrapper--hidden");
      if (slide_title == $(el).data("cattitle")) {
        $(el).removeClass("episode__wrapper--hidden");
        let episide_count = $(el).data("episodes-total");
      }
    });

    // Hacks
    $(".episode__wrapper").slick("slickGoTo", 0, true);
    if ($(window).width() <= 768) {
      setSlidesToScroll(2);
    } else {
      if (slide_title == "Space") setSlidesToScroll(5);
      else if (slide_title == "Forest") setSlidesToScroll(3);
      else if (slide_title == "Ocean") setSlidesToScroll(5);
      else if (slide_title == "Savanna") setSlidesToScroll(2);
      else if (slide_title == "Rainforest") setSlidesToScroll(3);
    }
  };

  // Makeup elems width, etc
  var makeupElems = function () {
    var total_width = 0;
    $("#view__categories")
      .find(".category__item")
      .each((i, e) => {
        total_width += $(e).outerWidth();
        $("#view__categories--body").css("width", total_width + 50 + "px");
      });
  };

  makeupElems();
  window.addEventListener("resize", makeupElems);

  // Select category
  $("#view__categories")
    .find(".category__item")
    .on("click", (e) => {
      onSlideSelect(e);
    });
};

export default CarouselCategories;
